import { ISettings } from '../interfaces/ISettings';

export const defaultSettings: ISettings = {
  eventLabelColors: {
    curbsideColor: 'rgb(3, 155, 229)',
    inOfficeColor: 'rgb(4, 204, 37)',
    reminder: 'rgb(154, 4, 204)',
  },
};
